import enMessages from '../../messages/en.json';
import viMessages from '../../messages/vi.json';

type JsonLike =
  | string
  | number
  | boolean
  | null
  | undefined
  | JsonLike[]
  | { [key: string]: JsonLike };

const EXTRA_VI_TEXT = new Map<string, string>([
  ['Open menu', 'Mở menu'],
  ['Menu', 'Menu'],
  ['Clear', 'Xóa'],
  ['Cancel', 'Hủy'],
  ['Create', 'Tạo'],
  ['Save', 'Lưu'],
  ['Delete', 'Xóa'],
  ['Retry', 'Thử lại'],
  ['Hide', 'Ẩn'],
  ['Search', 'Tìm kiếm'],
  ['Sort', 'Sắp xếp'],
  ['Newest', 'Mới nhất'],
  ['Oldest', 'Cũ nhất'],
  ['Loading', 'Đang tải'],
  ['Loading...', 'Đang tải...'],
  ['Creating...', 'Đang tạo...'],
  ['Saving...', 'Đang lưu...'],
  ['Uploading', 'Đang tải lên'],
  ['Processing', 'Đang xử lý'],
  ['Importing', 'Đang nhập'],
  ['View', 'Xem'],
  ['Details', 'Chi tiết'],
  ['Type', 'Loại'],
  ['Types', 'Các loại'],
  ['Visibility', 'Quyền hiển thị'],
  ['Workspace', 'Không gian làm việc'],
  ['Private', 'Riêng tư'],
  ['Selected', 'Đã chọn'],
  ['Language', 'Ngôn ngữ'],
  ['Timezone', 'Múi giờ'],
  ['UTC', 'UTC'],
  ['Save regional settings', 'Lưu cài đặt khu vực'],
  [
    'Use an IANA timezone like America/New_York or Asia/Kolkata.',
    'Sử dụng múi giờ IANA như America/New_York hoặc Asia/Kolkata.',
  ],
  ['Loading tech-pack', 'Đang tải bản thiết kế kỹ thuật'],
  [
    'Preparing standalone blueprint projects',
    'Đang chuẩn bị các dự án bản thiết kế độc lập',
  ],
  ['Loading workspace', 'Đang tải không gian làm việc'],
  ['Checking access', 'Đang kiểm tra quyền truy cập'],
  ['tech-pack', 'Bản thiết kế kỹ thuật'],
  [
    'Generate tech-pack projects, specifications, and manufacturing documentation',
    'Tạo bản thiết kế kỹ thuật, thông số kỹ thuật và tài liệu sản xuất',
  ],
  ['Create tech-pack', 'Tạo bản thiết kế kỹ thuật'],
  ['Create tech-pack', 'Tạo bản thiết kế kỹ thuật'],
  ['All Categories', 'Tất cả danh mục'],
  ['Name A-Z', 'Tên A-Z'],
  ['Name Z-A', 'Tên Z-A'],
  ['Search sort options...', 'Tìm tùy chọn sắp xếp...'],
  ['No sort options found.', 'Không tìm thấy tùy chọn sắp xếp nào.'],
  ['Search categories...', 'Tìm danh mục...'],
  ['No categories found.', 'Không tìm thấy danh mục nào.'],
  ['Search tech-pack...', 'Tìm kiếm bản thiết kế kỹ thuật...'],
  ['Clear search', 'Xóa tìm kiếm'],
  ['Grid size', 'Kích thước lưới'],
  ['No tech-pack projects yet.', 'Chưa có dự án bản thiết kế kỹ thuật nào.'],
  [
    'No tech-pack projects match your filters.',
    'Không có bản thiết kế kỹ thuật nào khớp với bộ lọc của bạn.',
  ],
  ['Untitled Product', 'Sản phẩm chưa có tên'],
  ['tech-pack', 'Bản thiết kế kỹ thuật'],
  ['Loading your library', 'Đang tải thư viện của bạn'],
  ['Fetching generated assets', 'Đang lấy các tài sản đã tạo'],
  ['Your Library', 'Thư viện của bạn'],
  ['Browse all generated assets', 'Duyệt tất cả tài sản đã tạo'],
  ['Chat Generations', 'Tạo từ cuộc trò chuyện'],
  ['Marketing Generations', 'Tạo cho tiếp thị'],
  ['Library menu', 'Menu thư viện'],
  [
    'Search by product, version, or prompt...',
    'Tìm theo sản phẩm, phiên bản hoặc prompt...',
  ],
  ['Search assets', 'Tìm kiếm tài sản'],
  ['All Types', 'Tất cả loại'],
  ['Images', 'Hình ảnh'],
  ['Videos', 'Video'],
  ['3D Models', 'Mô hình 3D'],
  [
    'Delete this version? Its assets will be removed, but the product will remain.',
    'Xóa phiên bản này? Tài sản của phiên bản sẽ bị xóa nhưng sản phẩm vẫn được giữ lại.',
  ],
  ['Failed to delete version', 'Không thể xóa phiên bản'],
  ['Product not found', 'Không tìm thấy sản phẩm'],
  [
    'The product you’re looking for doesn’t exist or you don’t have access to it.',
    'Sản phẩm bạn đang tìm không tồn tại hoặc bạn không có quyền truy cập.',
  ],
  ['Back to Design', 'Quay lại thiết kế'],
  ['New Brand', 'Thương hiệu mới'],
  ['Lets Get Started', 'Bắt đầu thôi'],
  ['Do You Have a Website?', 'Bạn có trang web không?'],
  ['Where Do You Post ?', 'Bạn đăng ở đâu?'],
  ['Got any brand images/pdf', 'Bạn có hình ảnh hoặc PDF thương hiệu không'],
  ['Review & create', 'Xem lại và tạo'],
  ['Enter Your Brand Name', 'Nhập tên thương hiệu của bạn'],
  ['Create', 'Tạo'],
  ['Gathering your Brand', 'Đang thu thập dữ liệu thương hiệu'],
  ['Preparing your Brand assets', 'Đang chuẩn bị tài sản thương hiệu của bạn'],
  ['Branding', 'Bộ nhận diện'],
  [
    'Add Your Logo, Color Palette, and Fonts to your Image Generation In One Step.',
    'Thêm logo, bảng màu và phông chữ vào quá trình tạo ảnh của bạn chỉ trong một bước.',
  ],
  [
    'Failed to load brandings. Please refresh the page.',
    'Không thể tải bộ nhận diện. Vui lòng làm mới trang.',
  ],
  ['Error details', 'Chi tiết lỗi'],
  ['just now', 'vừa xong'],
  ['Connectors', 'Trình kết nối'],
  [
    'Connect commerce, analytics, creative, and communication tools so your AI work flows where teams already operate.',
    'Kết nối công cụ thương mại, phân tích, sáng tạo và giao tiếp để công việc AI đi đúng nơi nhóm đang vận hành.',
  ],
  ['No connectors available right now.', 'Hiện không có trình kết nối nào.'],
  ['Open {name} connector', 'Mở trình kết nối {name}'],
  ['Access', 'Truy cập'],
  ['Coming Soon', 'Sắp ra mắt'],
  ['Prototyping', 'Tạo mẫu'],
  [
    'Move your AI-generated assets into your creative tools in a single step.',
    'Đưa tài sản AI đã tạo vào các công cụ sáng tạo của bạn chỉ trong một bước.',
  ],
  ['Ecommerce', 'Thương mại điện tử'],
  [
    'Publish visuals and product content directly to your commerce stack.',
    'Đăng trực tiếp hình ảnh và nội dung sản phẩm vào hệ thống thương mại của bạn.',
  ],
  ['Chats', 'Cuộc trò chuyện'],
  [
    'Run prompts and receive media outputs inside your existing conversations.',
    'Chạy prompt và nhận đầu ra phương tiện ngay trong các cuộc trò chuyện hiện có.',
  ],
  ['Web', 'Web'],
  [
    'Send generations to the browser where your team is already working.',
    'Gửi nội dung đã tạo tới trình duyệt nơi nhóm của bạn đang làm việc.',
  ],
  [
    'This connector is currently under development. We are working hard to bring you an amazing integration experience.',
    'Trình kết nối này hiện đang được phát triển. Chúng tôi đang nỗ lực để mang đến cho bạn trải nghiệm tích hợp tuyệt vời.',
  ],
  ['Back to Connectors', 'Quay lại Trình kết nối'],
  ['Avatars', 'Avatar'],
  ['Gathering avatars', 'Đang thu thập avatar'],
  [
    'Preparing your workspace avatars',
    'Đang chuẩn bị avatar cho không gian làm việc của bạn',
  ],
  [
    'Generate multi-image character reference packs (turnaround + headshots). Verified workspaces can also publish reusable avatar sets for every workspace.',
    'Tạo bộ tham chiếu nhân vật nhiều ảnh (xoay vòng + chân dung). Các không gian làm việc đã xác minh cũng có thể xuất bản bộ avatar tái sử dụng cho mọi không gian làm việc.',
  ],
  [
    'Create multi-image character packs with turnarounds and headshots. Verified workspaces can publish reusable avatar sets.',
    'Tạo bộ nhân vật nhiều ảnh với ảnh xoay vòng và chân dung. Các không gian làm việc đã xác minh có thể xuất bản bộ avatar tái sử dụng.',
  ],
  ['Your Workspace', 'Không gian làm việc của bạn'],
  ['Private & published', 'Riêng tư & đã xuất bản'],
  [
    'Avatars created in this workspace.',
    'Các avatar được tạo trong không gian làm việc này.',
  ],
  ['Published Avatar Sets', 'Bộ avatar đã xuất bản'],
  ['Verified publishers', 'Nhà xuất bản đã xác minh'],
  [
    'Reusable avatars from verified workspaces.',
    'Avatar tái sử dụng từ các không gian làm việc đã xác minh.',
  ],
  ['avatar', 'avatar'],
  ['avatars', 'avatar'],
  ['No avatars yet', 'Chưa có avatar nào'],
  [
    'Create your first avatar by describing a character in text.',
    'Tạo avatar đầu tiên của bạn bằng cách mô tả nhân vật bằng văn bản.',
  ],
  ['Delete avatar?', 'Xóa avatar?'],
  [
    'This will permanently delete this avatar and all generated shots. This cannot be undone.',
    'Thao tác này sẽ xóa vĩnh viễn avatar này và toàn bộ ảnh đã tạo. Không thể hoàn tác.',
  ],
  ['Deleting...', 'Đang xóa...'],
  ['Delete avatar', 'Xóa avatar'],
  ['Deleted {name}', 'Đã xóa {name}'],
  ['Created', 'Đã tạo'],
  ['Published by', 'Xuất bản bởi'],
  ['Verified workspace', 'Không gian làm việc đã xác minh'],
  ['Published', 'Đã xuất bản'],
  ['Workspace navigation', 'Điều hướng không gian làm việc'],
  ['Only failed shots', 'Chỉ ảnh lỗi'],
  [
    'Retry images that did not generate successfully.',
    'Tạo lại những ảnh không tạo thành công.',
  ],
  ['Everything', 'Tất cả'],
  [
    'Regenerate every shot for this avatar from scratch.',
    'Tạo lại toàn bộ ảnh cho avatar này từ đầu.',
  ],
  ['Starting...', 'Đang bắt đầu...'],
  ['Start regeneration', 'Bắt đầu tạo lại'],
  ['Loading avatar', 'Đang tải avatar'],
  ['Preparing the avatar reference pack', 'Đang chuẩn bị bộ tham chiếu avatar'],
  ['Avatar not found', 'Không tìm thấy avatar'],
  ['Preparing your avatar generation…', 'Đang chuẩn bị quá trình tạo avatar…'],
  [
    'Model card: standardized face + full-body shots (same angles + wardrobe) to keep this avatar consistent across generations.',
    'Thẻ model: ảnh khuôn mặt chuẩn hóa + toàn thân (cùng góc chụp + trang phục) để giữ avatar này nhất quán giữa các lần tạo.',
  ],
  ['Status:', 'Trạng thái:'],
  ['Edit details', 'Chỉnh sửa chi tiết'],
  ['Publishing', 'Đang xuất bản'],
  ['Publish', 'Xuất bản'],
  ['Regenerate avatar', 'Tạo lại avatar'],
  [
    'Restart generation for this avatar.',
    'Khởi động lại quá trình tạo cho avatar này.',
  ],
  ['Edit avatar details', 'Chỉnh sửa chi tiết avatar'],
  [
    'Update the name and add a one-line personality description.',
    'Cập nhật tên và thêm mô tả tính cách trong một dòng.',
  ],
  [
    'Control who can discover and reuse this avatar.',
    'Kiểm soát ai có thể tìm thấy và tái sử dụng avatar này.',
  ],
  ['Name is required', 'Bắt buộc phải có tên'],
  ['Saving details...', 'Đang lưu chi tiết...'],
  ['Details updated', 'Đã cập nhật chi tiết'],
  ['Failed to save details', 'Không thể lưu chi tiết'],
  ['Failed to start generation', 'Không thể bắt đầu tạo'],
  ['Avatar deleted', 'Đã xóa avatar'],
  ['Saving publishing settings...', 'Đang lưu cài đặt xuất bản...'],
  ['Publishing settings updated', 'Đã cập nhật cài đặt xuất bản'],
  ['Failed to save publishing', 'Không thể lưu cài đặt xuất bản'],
  ['Avatar name', 'Tên avatar'],
  ['Description', 'Mô tả'],
  [
    "One-liner about this avatar's personality or vibe",
    'Một dòng mô tả tính cách hoặc phong cách của avatar này',
  ],
  [
    'Keep it short and specific (e.g., “Calm, thoughtful mentor who explains ideas clearly.”)',
    'Giữ mô tả ngắn gọn và cụ thể (ví dụ: “Người cố vấn điềm tĩnh, sâu sắc, giải thích ý tưởng rõ ràng.”)',
  ],
  ['Visibility', 'Quyền hiển thị'],
  ['Workspace only', 'Chỉ trong không gian làm việc'],
  ['Publish to all workspaces', 'Xuất bản cho tất cả không gian làm việc'],
  [
    'Global avatars become reusable across every workspace.',
    'Avatar toàn cục có thể được tái sử dụng trên mọi không gian làm việc.',
  ],
  ['Untitled document', 'Tài liệu chưa có tiêu đề'],
  ['Opening documents', 'Đang mở tài liệu'],
  [
    'Preparing your workspace notes',
    'Đang chuẩn bị ghi chú không gian làm việc của bạn',
  ],
  ['Gathering workspace notes', 'Đang thu thập ghi chú không gian làm việc'],
  ['Failed to create document', 'Không thể tạo tài liệu'],
  ['Book updated', 'Đã cập nhật sổ'],
  ['Book created', 'Đã tạo sổ'],
  ['Failed to save book', 'Không thể lưu sổ'],
  ['Delete book?', 'Xóa sổ?'],
  [
    'Documents in this book will be moved back to the main documents list.',
    'Các tài liệu trong sổ này sẽ được chuyển lại danh sách tài liệu chính.',
  ],
  ['Book deleted', 'Đã xóa sổ'],
  ['Failed to delete book', 'Không thể xóa sổ'],
  ['Moved to book', 'Đã chuyển vào sổ'],
  ['Failed to move document', 'Không thể chuyển tài liệu'],
  ['All docs', 'Tất cả tài liệu'],
  ['New book', 'Sổ mới'],
  ['New doc', 'Tài liệu mới'],
  ['Search documents and books', 'Tìm kiếm tài liệu và sổ'],
  ['doc', 'tài liệu'],
  ['docs', 'tài liệu'],
  ['Rename', 'Đổi tên'],
  ['No documents yet', 'Chưa có tài liệu nào'],
  ['No matching documents or books', 'Không có tài liệu hoặc sổ nào khớp'],
  [
    'Create your first document or book to capture richer product and thread feedback.',
    'Tạo tài liệu hoặc sổ đầu tiên để lưu phản hồi chi tiết hơn về sản phẩm và cuộc trò chuyện.',
  ],
  ['Try a different search term.', 'Hãy thử một từ khóa khác.'],
  ['Move to', 'Chuyển đến'],
  ['Shared', 'Đã chia sẻ'],
  ['Shared from', 'Được chia sẻ từ'],
  ['Shared document', 'Tài liệu được chia sẻ'],
  ['Rename book', 'Đổi tên sổ'],
  ['Create book', 'Tạo sổ'],
  ['Update the name for this book.', 'Cập nhật tên cho sổ này.'],
  [
    'Books are document folders, like in Vector.',
    'Sổ là các thư mục tài liệu, giống như trong Vector.',
  ],
  ['Weekly reviews', 'Đánh giá hàng tuần'],
  ['Opening document', 'Đang mở tài liệu'],
  ['Loading editor state', 'Đang tải trạng thái trình soạn thảo'],
  ['Delete document?', 'Xóa tài liệu?'],
  [
    'This will permanently remove the document and its mention index.',
    'Thao tác này sẽ xóa vĩnh viễn tài liệu và chỉ mục nhắc đến của nó.',
  ],
  ['Document deleted', 'Đã xóa tài liệu'],
  ['Failed to delete document', 'Không thể xóa tài liệu'],
  ['Document shared', 'Đã chia sẻ tài liệu'],
  ['Failed to share document', 'Không thể chia sẻ tài liệu'],
  ['Workspace share removed', 'Đã xóa chia sẻ với không gian làm việc'],
  [
    'Failed to remove workspace share',
    'Không thể xóa chia sẻ với không gian làm việc',
  ],
  ['Gathering editor data', 'Đang thu thập dữ liệu trình soạn thảo'],
  ['Document not found', 'Không tìm thấy tài liệu'],
  [
    'This document no longer exists, or the link points to a different workspace.',
    'Tài liệu này không còn tồn tại hoặc liên kết trỏ tới một không gian làm việc khác.',
  ],
  ['Back to documents', 'Quay lại tài liệu'],
  ['Saving…', 'Đang lưu…'],
  ['Unsaved changes', 'Thay đổi chưa được lưu'],
  ['Documents', 'Tài liệu'],
  ['Share', 'Chia sẻ'],
  ['Move to book', 'Chuyển vào sổ'],
  ['Remove from book', 'Xóa khỏi sổ'],
  ['Read-only in this workspace.', 'Chỉ đọc trong không gian làm việc này.'],
  ['This document is shared from', 'Tài liệu này được chia sẻ từ'],
  [
    'Start writing... Use / for commands and @ to mention products, threads, and assets.',
    'Bắt đầu viết... Dùng / cho lệnh và @ để nhắc đến sản phẩm, cuộc trò chuyện và tài sản.',
  ],
  [
    'Share to verified Workspaces',
    'Chia sẻ tới các không gian làm việc đã xác minh',
  ],
  [
    'Shared documents appear in the Shared section for the target Workspace. Recipient Workspaces get read-only access.',
    'Tài liệu được chia sẻ sẽ xuất hiện trong mục Đã chia sẻ của không gian làm việc đích. Không gian làm việc nhận sẽ có quyền chỉ đọc.',
  ],
  ['Currently shared with', 'Hiện đang chia sẻ với'],
  ['Unknown Workspace', 'Không gian làm việc không xác định'],
  ['Workspace unavailable', 'Không gian làm việc không khả dụng'],
  ['Opening book', 'Đang mở sổ'],
  ['Loading documents in this book', 'Đang tải tài liệu trong sổ này'],
  ['Gathering documents', 'Đang thu thập tài liệu'],
  ['Removed from book', 'Đã xóa khỏi sổ'],
  ['Failed to update book', 'Không thể cập nhật sổ'],
  ['Search this book', 'Tìm trong sổ này'],
  ['No documents in this book', 'Không có tài liệu nào trong sổ này'],
  ['No matching documents', 'Không có tài liệu nào khớp'],
  [
    'Create a document in this book to keep related notes together.',
    'Tạo tài liệu trong sổ này để giữ các ghi chú liên quan cùng nhau.',
  ],
  ['Loading your references', 'Đang tải tài liệu tham chiếu của bạn'],
  [
    'Preparing your reference library',
    'Đang chuẩn bị thư viện tham chiếu của bạn',
  ],
  ['Loading references', 'Đang tải tài liệu tham chiếu'],
  ['Fetching your reference library', 'Đang lấy thư viện tham chiếu của bạn'],
  ['User not found', 'Không tìm thấy người dùng'],
  ['Unable to load user information', 'Không thể tải thông tin người dùng'],
  ['Workspace not found', 'Không tìm thấy không gian làm việc'],
  ['Moving you along...', 'Đang chuyển bạn đi...'],
  ['Drop to upload references', 'Thả để tải lên tài liệu tham chiếu'],
  [
    'Files will be visible to your workspace',
    'Các tệp sẽ hiển thị với không gian làm việc của bạn',
  ],
  ['selected', 'đã chọn'],
  ['Deselect all', 'Bỏ chọn tất cả'],
  ['Select all', 'Chọn tất cả'],
  ['My References', 'Tài liệu tham chiếu của tôi'],
  [
    'Upload and organize files for AI context',
    'Tải lên và sắp xếp tệp cho ngữ cảnh AI',
  ],
  ['Upload', 'Tải lên'],
  ['Search references...', 'Tìm kiếm tài liệu tham chiếu...'],
  ['All', 'Tất cả'],
  ['Search Results', 'Kết quả tìm kiếm'],
  ['No references found', 'Không tìm thấy tài liệu tham chiếu nào'],
  [
    "Try adjusting your filters to find what you're looking for.",
    'Hãy thử điều chỉnh bộ lọc để tìm nội dung bạn cần.',
  ],
  [
    'Upload files to start building your reference library.',
    'Tải lên tệp để bắt đầu xây dựng thư viện tham chiếu của bạn.',
  ],
  ['Design', 'Thiết kế'],
  ['Product', 'Sản phẩm'],
  ['Color', 'Màu sắc'],
  ['Material', 'Chất liệu'],
  ['References:', 'Tài liệu tham chiếu:'],
  ['Document', 'Tài liệu'],
  ['Make Workspace', 'Chuyển thành không gian làm việc'],
  ['Make Private', 'Chuyển thành riêng tư'],
  ['Generating specs', 'Đang tạo thông số'],
  ['Type Folder', 'Thư mục loại'],
  ['File', 'Tệp'],
  ['Reference', 'Tham chiếu'],
  ['File type', 'Loại tệp'],
  ['Size', 'Kích thước'],
  ['Added', 'Đã thêm'],
  ['Image', 'Hình ảnh'],
  ['Video', 'Video'],
  ['Audio', 'Âm thanh'],
  ['3D', '3D'],
  ['Delete reference?', 'Xóa tài liệu tham chiếu?'],
  ['Delete {count} references?', 'Xóa {count} tài liệu tham chiếu?'],
  [
    'Are you sure you want to delete this reference? This action cannot be undone.',
    'Bạn có chắc muốn xóa tài liệu tham chiếu này không? Không thể hoàn tác hành động này.',
  ],
  [
    'Are you sure you want to delete these {count} references? This action cannot be undone.',
    'Bạn có chắc muốn xóa {count} tài liệu tham chiếu này không? Không thể hoàn tác hành động này.',
  ],
  ['Loading reference', 'Đang tải tài liệu tham chiếu'],
  ['Preparing your reference', 'Đang chuẩn bị tài liệu tham chiếu của bạn'],
  ['Loading downloads', 'Đang tải xuống'],
  [
    'Collecting your recent file packages',
    'Đang thu thập các gói tệp gần đây của bạn',
  ],
  ['Loading download jobs', 'Đang tải các tác vụ tải xuống'],
  [
    'Fetching your workspace jobs',
    'Đang lấy các tác vụ của không gian làm việc',
  ],
  ['Moving you to dashboard...', 'Đang chuyển bạn đến bảng điều khiển...'],
  ['Downloads', 'Tải xuống'],
  [
    'Prepared files stay available for 24 hours before expiring.',
    'Các tệp đã chuẩn bị sẽ khả dụng trong 24 giờ trước khi hết hạn.',
  ],
  ['Preparing', 'Đang chuẩn bị'],
  ['Ready', 'Sẵn sàng'],
  ['Needs retry', 'Cần thử lại'],
  ['No jobs in this view yet.', 'Chưa có tác vụ nào trong chế độ xem này.'],
  ['Download package', 'Tải gói xuống'],
  ['Download', 'Tải xuống'],
  ['Open product', 'Mở sản phẩm'],
  ['Generation Options', 'Tùy chọn tạo'],
  [
    'Fine-tune how your 3D model is generated.',
    'Tinh chỉnh cách mô hình 3D của bạn được tạo.',
  ],
  ['Efficient Generation', 'Tạo hiệu quả'],
  [
    'Using a single main image for fast generation (5 credits).',
    'Sử dụng một ảnh chính để tạo nhanh (5 tín dụng).',
  ],
  ['Output Type', 'Loại đầu ra'],
  ['Full Textured', 'Đầy đủ kết cấu'],
  ['Standard high-quality mesh', 'Lưới tiêu chuẩn chất lượng cao'],
  ['Geometry Only', 'Chỉ hình học'],
  ['No textures, fast generation', 'Không có kết cấu, tạo nhanh'],
  ['Low Poly', 'Low Poly'],
  ['Optimized for web and games', 'Tối ưu cho web và trò chơi'],
  ['Enable PBR Materials', 'Bật vật liệu PBR'],
  [
    'Physically based rendering for realistic lighting.',
    'Kết xuất dựa trên vật lý cho ánh sáng chân thực.',
  ],
  ['Mesh Complexity', 'Độ phức tạp của lưới'],
  [
    'Target face count for the generated 3D model.',
    'Số mặt mục tiêu cho mô hình 3D được tạo.',
  ],
  ['Low Detail', 'Ít chi tiết'],
  ['High Detail', 'Nhiều chi tiết'],
  ['Generate 3D Model', 'Tạo mô hình 3D'],
  ['3D Model Generation', 'Tạo mô hình 3D'],
  ['Multi-view Reconstruction', 'Tái tạo đa góc nhìn'],
  [
    'AI analyzes your product from every angle to build an accurate, detailed 3D mesh automatically.',
    'AI phân tích sản phẩm của bạn từ mọi góc độ để tự động xây dựng lưới 3D chính xác và chi tiết.',
  ],
  ['PBR & Mesh Control', 'Điều khiển PBR & lưới'],
  [
    'Fine-tune output type, enable physically based rendering, and dial in mesh complexity.',
    'Tinh chỉnh loại đầu ra, bật kết xuất dựa trên vật lý và điều chỉnh độ phức tạp của lưới.',
  ],
  ['Production-ready GLB', 'GLB sẵn sàng cho sản xuất'],
  [
    'Download industry-standard GLB files ready for e-commerce, AR experiences, and rendering pipelines.',
    'Tải xuống các tệp GLB tiêu chuẩn ngành sẵn sàng cho thương mại điện tử, trải nghiệm AR và pipeline kết xuất.',
  ],
  ['Interactive Preview', 'Xem trước tương tác'],
  [
    'Rotate, zoom, and inspect your 3D model directly in the browser before exporting.',
    'Xoay, phóng to và kiểm tra mô hình 3D của bạn trực tiếp trong trình duyệt trước khi xuất.',
  ],
  ['Multiple Output Types', 'Nhiều loại đầu ra'],
  [
    'Choose between full-textured, geometry-only, or low-poly models optimized for different use cases.',
    'Chọn giữa mô hình đầy đủ kết cấu, chỉ hình học hoặc low-poly được tối ưu cho các trường hợp sử dụng khác nhau.',
  ],
  ['Single-image AI', 'AI từ một ảnh'],
  [
    'No multi-angle photography needed. One product photo is all it takes to generate a full 3D asset.',
    'Không cần chụp nhiều góc. Chỉ một ảnh sản phẩm là đủ để tạo ra tài sản 3D hoàn chỉnh.',
  ],
  ['Ready to generate', 'Sẵn sàng tạo'],
  [
    'Your main product image will be used to create a 3D model. You will be able to configure output type, PBR materials, and mesh complexity on the next screen. Generation costs 5 credits per model.',
    'Ảnh chính của sản phẩm sẽ được dùng để tạo mô hình 3D. Bạn sẽ có thể cấu hình loại đầu ra, vật liệu PBR và độ phức tạp của lưới ở màn hình tiếp theo. Chi phí tạo là 5 tín dụng cho mỗi mô hình.',
  ],
  ['Configure & Generate', 'Cấu hình & tạo'],
  [
    'Generate 3D models from your product images using AI',
    'Tạo mô hình 3D từ ảnh sản phẩm của bạn bằng AI',
  ],
  ['Generating...', 'Đang tạo...'],
  ['Generate New 3D Model', 'Tạo mô hình 3D mới'],
  [
    'Generating 3D model... This may take a few minutes.',
    'Đang tạo mô hình 3D... Quá trình này có thể mất vài phút.',
  ],
  ['Loading model...', 'Đang tải mô hình...'],
  ['Preview', 'Xem trước'],
  ['Main image is required', 'Bắt buộc phải có ảnh chính'],
  ['3D model generation started', 'Đã bắt đầu tạo mô hình 3D'],
  [
    'The 3D model is being generated from a single image (5 credits charged). It will appear here when ready.',
    'Mô hình 3D đang được tạo từ một ảnh (đã trừ 5 tín dụng). Nó sẽ xuất hiện ở đây khi sẵn sàng.',
  ],
  ['Failed to generate 3D model', 'Không thể tạo mô hình 3D'],
  ['3D model generation failed', 'Tạo mô hình 3D thất bại'],
  ['Click Undo to cancel', 'Nhấn Hoàn tác để hủy'],
  ['Generation cancelled', 'Đã hủy tạo'],
  ['3D model deleted', 'Đã xóa mô hình 3D'],
  ['Failed to delete 3D model', 'Không thể xóa mô hình 3D'],
  ['Delete failed', 'Xóa thất bại'],
  ['Close', 'Đóng'],
  ['Previous', 'Trước'],
  ['Next', 'Tiếp theo'],
  [
    'Fullscreen media viewer. Press Escape to close. Use left and right arrows to navigate.',
    'Trình xem phương tiện toàn màn hình. Nhấn Escape để đóng. Dùng phím mũi tên trái và phải để điều hướng.',
  ],
  ['Loading full image', 'Đang tải ảnh đầy đủ'],
  ['Loading 3D viewer...', 'Đang tải trình xem 3D...'],
  ['No source provided', 'Không có nguồn nào được cung cấp'],
  ['Failed to load 3D viewer library', 'Không thể tải thư viện trình xem 3D'],
  ['Failed to load 3D model', 'Không thể tải mô hình 3D'],
  ['Failed to load video', 'Không thể tải video'],
  ['Video loading aborted', 'Đã hủy tải video'],
  ['Network error loading video', 'Lỗi mạng khi tải video'],
  ['Video decoding error', 'Lỗi giải mã video'],
  ['Video format not supported', 'Định dạng video không được hỗ trợ'],
  ['No video source available', 'Không có nguồn video khả dụng'],
  ['Loading video...', 'Đang tải video...'],
  ['Video Asset', 'Tài sản video'],
  ['URL not accessible', 'Không thể truy cập URL'],
  ['URL accessible', 'Có thể truy cập URL'],
  ['Yes', 'Có'],
  ['No', 'Không'],
  ['Source', 'Nguồn'],
  ['Sidebar', 'Thanh bên'],
  ['Displays the mobile sidebar.', 'Hiển thị thanh bên trên thiết bị di động.'],
  ['Toggle Sidebar', 'Bật/tắt thanh bên'],
  ['More pages', 'Nhiều trang hơn'],
  ['Go to previous page', 'Đi đến trang trước'],
  ['Go to next page', 'Đi đến trang tiếp theo'],
  ['Page not found', 'Không tìm thấy trang'],
  [
    "The page you are looking for doesn't exist or has been moved.",
    'Trang bạn đang tìm không tồn tại hoặc đã được chuyển đi.',
  ],
  ['Go home', 'Về trang chủ'],
  ['Go to dashboard', 'Đi đến bảng điều khiển'],
  ['Error', 'Lỗi'],
  ['Something went wrong', 'Đã xảy ra lỗi'],
  ['An unexpected error occurred.', 'Đã xảy ra lỗi không mong muốn.'],
  ['Try again', 'Thử lại'],
  [
    'Please try again. If this keeps happening, contact support.',
    'Vui lòng thử lại. Nếu sự cố này tiếp diễn, hãy liên hệ hỗ trợ.',
  ],
  ['Reference', 'Tham chiếu'],
  ['Media Studio', 'Media Studio'],
  ['Catalogue Data', 'Dữ liệu danh mục'],
  ['Manufacturing', 'Sản xuất'],
  ['Prints & Patterns', 'Bản in & Hoa văn'],
  ['New chat', 'Cuộc trò chuyện mới'],
  ['Chat with this product', 'Trò chuyện với sản phẩm này'],
  ['New tab', 'Tab mới'],
  ['Failed to process message', 'Không thể xử lý tin nhắn'],
  [
    'Ask anything or @mention an asset...',
    'Hỏi bất cứ điều gì hoặc @nhắc đến một tài sản...',
  ],
  ['Main', 'Chính'],
  ['Main asset', 'Tài sản chính'],
  ['Generating image', 'Đang tạo ảnh'],
  ['Product Listing', 'Danh sách sản phẩm'],
  ['Social Media', 'Mạng xã hội'],
  ['Lifestyle', 'Phong cách sống'],
  ['Detail', 'Chi tiết'],
  ['Layout view', 'Chế độ xem bố cục'],
  ['Grouped view', 'Chế độ xem nhóm'],
  ['All assets view', 'Chế độ xem tất cả tài sản'],
  ['List view', 'Chế độ xem danh sách'],
  ['Exit selection mode', 'Thoát chế độ chọn'],
  ['Selecting', 'Đang chọn'],
  ['Select assets', 'Chọn tài sản'],
  ['Select', 'Chọn'],
  ['Clear selection', 'Xóa lựa chọn'],
  ['Download selected', 'Tải xuống mục đã chọn'],
  ['Mention selected in chat', 'Nhắc tới mục đã chọn trong trò chuyện'],
  ['Mention', 'Nhắc đến'],
  ['Delete selected', 'Xóa mục đã chọn'],
  ['Edit asset', 'Chỉnh sửa tài sản'],
  ['View full screen', 'Xem toàn màn hình'],
  ['Delete asset', 'Xóa tài sản'],
  ['Delete this asset?', 'Xóa tài sản này?'],
  ['Select Asset', 'Chọn tài sản'],
  [
    'Choose an asset to discuss in the chat',
    'Chọn một tài sản để thảo luận trong cuộc trò chuyện',
  ],
  ['Version', 'Phiên bản'],
  ['No version selected', 'Chưa chọn phiên bản'],
  ['No main asset', 'Không có tài sản chính'],
  ['New', 'Mới'],
  ['Selected Asset', 'Tài sản đã chọn'],
  ['3D Model', 'Mô hình 3D'],
  ['Replace asset', 'Thay thế tài sản'],
  ['Maximize asset', 'Phóng to tài sản'],
  ['Minimize asset', 'Thu nhỏ tài sản'],
  ['Asset preview', 'Xem trước tài sản'],
  ['Image', 'Hình ảnh'],
  ['Open asset', 'Mở tài sản'],
  ['Select file for download', 'Chọn tệp để tải xuống'],
  ['Deselect file', 'Bỏ chọn tệp'],
  ['Generating video', 'Đang tạo video'],
  ['Fine tuning image', 'Đang tinh chỉnh ảnh'],
  [
    'Failed to schedule account deactivation.',
    'Không thể lên lịch vô hiệu hóa tài khoản.',
  ],
  ['Pending deactivation', 'Đang chờ vô hiệu hóa'],
  ['Deactivated', 'Đã vô hiệu hóa'],
  ['Active', 'Đang hoạt động'],
  [
    'Sign in again within 14 days to cancel the request automatically.',
    'Đăng nhập lại trong vòng 14 ngày để tự động hủy yêu cầu.',
  ],
  [
    'Scheduled for {date}. Sign in again before then to cancel it automatically.',
    'Đã lên lịch vào {date}. Hãy đăng nhập lại trước thời điểm đó để tự động hủy.',
  ],
  [
    'This account is currently deactivated.',
    'Tài khoản này hiện đang bị vô hiệu hóa.',
  ],
  ['Deactivated on {date}.', 'Đã vô hiệu hóa vào {date}.'],
  [
    'Your account has full access.',
    'Tài khoản của bạn có đầy đủ quyền truy cập.',
  ],
  ['Account Deactivation', 'Vô hiệu hóa tài khoản'],
  [
    'Turn off your account without deleting your work.',
    'Tắt tài khoản của bạn mà không xóa công việc.',
  ],
  ['Deactivation is already scheduled.', 'Việc vô hiệu hóa đã được lên lịch.'],
  [
    'The account is set to deactivate on {date}.',
    'Tài khoản sẽ bị vô hiệu hóa vào {date}.',
  ],
  ['Deactivate account', 'Vô hiệu hóa tài khoản'],
  [
    'This is a soft deactivation. Your images, workspaces, and history stay intact. You will be signed out immediately. If you sign in again within 14 days, the request is canceled automatically. After 14 days, the account stays deactivated until you reactivate it from the sign-in screen.',
    'Đây là vô hiệu hóa mềm. Hình ảnh, không gian làm việc và lịch sử của bạn vẫn được giữ nguyên. Bạn sẽ bị đăng xuất ngay lập tức. Nếu đăng nhập lại trong vòng 14 ngày, yêu cầu sẽ tự động bị hủy. Sau 14 ngày, tài khoản sẽ tiếp tục bị vô hiệu hóa cho đến khi bạn kích hoạt lại từ màn hình đăng nhập.',
  ],
  ['Deactivation Pending', 'Đang chờ vô hiệu hóa'],
  ['Deactivate Account', 'Vô hiệu hóa tài khoản'],
  ['Deactivate account?', 'Vô hiệu hóa tài khoản?'],
  [
    'You will be signed out now. Type {phrase} to confirm.',
    'Bạn sẽ bị đăng xuất ngay bây giờ. Gõ {phrase} để xác nhận.',
  ],
  [
    'Signing in again within 14 days cancels the request. After that, you will need to reactivate the account from the auth screen.',
    'Đăng nhập lại trong vòng 14 ngày sẽ hủy yêu cầu. Sau đó, bạn sẽ cần kích hoạt lại tài khoản từ màn hình xác thực.',
  ],
  ['Confirmation text', 'Văn bản xác nhận'],
  ['No pending invitations', 'Không có lời mời nào đang chờ'],
  [
    "You don't have any pending invitations at the moment.",
    'Hiện tại bạn không có lời mời nào đang chờ.',
  ],
  ['Pending invitations list', 'Danh sách lời mời đang chờ'],
  ['Someone', 'Ai đó'],
  ['Admin', 'Quản trị viên'],
  ['Member', 'Thành viên'],
  ['Unknown organization', 'Tổ chức không xác định'],
  ['Invited by', 'Được mời bởi'],
  ['Expired', 'Đã hết hạn'],
  ['{role} access includes:', 'Quyền truy cập của {role} bao gồm:'],
  [
    'Manage workspace settings and members',
    'Quản lý cài đặt và thành viên của không gian làm việc',
  ],
  [
    'Create and edit products, assets, and threads',
    'Tạo và chỉnh sửa sản phẩm, tài sản và cuộc trò chuyện',
  ],
  [
    'Use workspace tools and generation features',
    'Sử dụng công cụ của không gian làm việc và các tính năng tạo nội dung',
  ],
  [
    'Review activity and collaborate across the workspace',
    'Xem hoạt động và cộng tác trên toàn không gian làm việc',
  ],
  [
    'View and collaborate inside the workspace',
    'Xem và cộng tác trong không gian làm việc',
  ],
  [
    'Create and edit content you have access to',
    'Tạo và chỉnh sửa nội dung mà bạn có quyền truy cập',
  ],
  [
    'Use approved workspace tools and shared resources',
    'Sử dụng công cụ được phê duyệt của không gian làm việc và các tài nguyên dùng chung',
  ],
  ['This invitation expires in', 'Lời mời này sẽ hết hạn sau'],
  ['This invitation has expired.', 'Lời mời này đã hết hạn.'],
  ['Accept invitation', 'Chấp nhận lời mời'],
  ['Accepting...', 'Đang chấp nhận...'],
  ['Decline invitation', 'Từ chối lời mời'],
  ['Declining...', 'Đang từ chối...'],
  ['Paid', 'Đã thanh toán'],
  ['Pending', 'Đang chờ'],
  ['Canceled', 'Đã hủy'],
  ['Monthly', 'Hàng tháng'],
  ['Annual', 'Hàng năm'],
  ['Generate All', 'Tạo tất cả'],
  ['Generate Images', 'Tạo hình ảnh'],
  ['Generate Details', 'Tạo chi tiết'],
  ['Generate Images Only', 'Chỉ tạo hình ảnh'],
  ['Generate Details Only', 'Chỉ tạo chi tiết'],
  ['Choose generation mode', 'Chọn chế độ tạo'],
  ['Viewpoints', 'Góc nhìn'],
  ['Copy All', 'Sao chép tất cả'],
  ['Export as PDF', 'Xuất dưới dạng PDF'],
  [
    'Generating images and product details...',
    'Đang tạo hình ảnh và chi tiết sản phẩm...',
  ],
  ['Generating listing images...', 'Đang tạo ảnh danh sách...'],
  ['Generating product details...', 'Đang tạo chi tiết sản phẩm...'],
  ['Stopping generations...', 'Đang dừng quá trình tạo...'],
  ['Stop', 'Dừng'],
  ['Generating product images...', 'Đang tạo ảnh sản phẩm...'],
  ['No product images yet', 'Chưa có ảnh sản phẩm nào'],
  [
    'Click "Generate All" to create listing images',
    'Nhấn "Tạo tất cả" để tạo ảnh danh sách',
  ],
  ['Listing Image', 'Ảnh danh sách'],
  ['Stopping image generation...', 'Đang dừng quá trình tạo ảnh...'],
  ['Stop Generation', 'Dừng tạo'],
  ['360° Turntable Video', 'Video xoay 360°'],
  [
    'Generating video — this may take a few minutes...',
    'Đang tạo video — quá trình này có thể mất vài phút...',
  ],
  ['Video generated', 'Đã tạo video'],
  ['10s turntable video', 'Video xoay 10 giây'],
  ['Regenerate', 'Tạo lại'],
  ['More viewpoints', 'Nhiều góc nhìn hơn'],
  ['Core views', 'Góc nhìn cốt lõi'],
  ['Detail views', 'Góc nhìn chi tiết'],
  ['Product-specific', 'Theo từng sản phẩm'],
  ['Fit & usage', 'Độ vừa vặn & cách dùng'],
  ['Packaging & trust', 'Bao bì & độ tin cậy'],
  [
    'Started generating 360° turntable video...',
    'Đã bắt đầu tạo video xoay 360°...',
  ],
  ['Failed to start 360° video', 'Không thể bắt đầu video 360°'],
  ['Failed to start 360° video generation', 'Không thể bắt đầu tạo video 360°'],
  ['Generate Video', 'Tạo video'],
  ['Key Features', 'Tính năng chính'],
  ['Dimensions', 'Kích thước'],
  ['Weight', 'Trọng lượng'],
  ['Origin', 'Xuất xứ'],
  ['Warranty', 'Bảo hành'],
  ['About this product', 'Về sản phẩm này'],
  ['No product details yet', 'Chưa có chi tiết sản phẩm nào'],
  [
    'Use "Generate All" or select "Generate Details Only" from the dropdown above.',
    'Sử dụng "Tạo tất cả" hoặc chọn "Chỉ tạo chi tiết" từ menu thả xuống phía trên.',
  ],
  ['Analyzing product images...', 'Đang phân tích ảnh sản phẩm...'],
  [
    'Extracting descriptions, specs, and features',
    'Đang trích xuất mô tả, thông số và tính năng',
  ],
  ['Product Details', 'Chi tiết sản phẩm'],
  ['Regenerate Details', 'Tạo lại chi tiết'],
  ['Stopping details generation...', 'Đang dừng quá trình tạo chi tiết...'],
  [
    'All catalogue data copied to clipboard',
    'Đã sao chép toàn bộ dữ liệu danh mục vào bảng tạm',
  ],
  ['Failed to copy to clipboard', 'Không thể sao chép vào bảng tạm'],
  [
    'No catalogue data available to export',
    'Không có dữ liệu danh mục để xuất',
  ],
  ['Generating PDF report...', 'Đang tạo báo cáo PDF...'],
  ['PDF report downloaded successfully', 'Đã tải xuống báo cáo PDF thành công'],
  ['Failed to generate PDF report', 'Không thể tạo báo cáo PDF'],
  [
    'Started generating product details...',
    'Đã bắt đầu tạo chi tiết sản phẩm...',
  ],
  [
    'Failed to start generating product details',
    'Không thể bắt đầu tạo chi tiết sản phẩm',
  ],
  ['Failed to generate assets', 'Không thể tạo tài sản'],
  ['Failed to regenerate assets', 'Không thể tạo lại tài sản'],
  ['Product Description', 'Mô tả sản phẩm'],
  ['detail', 'chi tiết'],
  ['Add to chat', 'Thêm vào trò chuyện'],
  ['Copy', 'Sao chép'],
  ['Copied to clipboard', 'Đã sao chép vào bảng tạm'],
  ['Added to chat', 'Đã thêm vào trò chuyện'],
  ['Failed to add to chat', 'Không thể thêm vào trò chuyện'],
  ['Edit {label}', 'Chỉnh sửa {label}'],
  ['Description updated', 'Đã cập nhật mô tả'],
  ['Failed to update description', 'Không thể cập nhật mô tả'],
  ['Enter product description...', 'Nhập mô tả sản phẩm...'],
  ['Save Changes', 'Lưu thay đổi'],
  ['Primary Features', 'Tính năng chính'],
  ['Additional Features', 'Tính năng bổ sung'],
  ['Unique Characteristics', 'Đặc điểm nổi bật'],
  ['Quality Indicators', 'Chỉ báo chất lượng'],
  ['Material & Specifications', 'Chất liệu & Thông số'],
  ['Specifications', 'Thông số kỹ thuật'],
  ['Primary Materials', 'Chất liệu chính'],
  ['Secondary Materials', 'Chất liệu phụ'],
  ['Colors', 'Màu sắc'],
  ['Care Instructions', 'Hướng dẫn bảo quản'],
  ['Technical Specs', 'Thông số kỹ thuật'],
  ['Product Highlights', 'Điểm nổi bật của sản phẩm'],
  ['What Makes It Special', 'Điều làm nó đặc biệt'],
  ['Best Use Cases', 'Trường hợp sử dụng phù hợp nhất'],
  ['Ideal Customer', 'Khách hàng lý tưởng'],
  ['Value Proposition', 'Giá trị cốt lõi'],
  ['Additional Details', 'Chi tiết bổ sung'],
  ['Brand Info', 'Thông tin thương hiệu'],
  ['Packaging', 'Bao bì'],
  ['Shipping', 'Vận chuyển'],
  ['Highlight', 'Điểm nhấn'],
  ['Pattern Extraction', 'Trích xuất hoa văn'],
  [
    'Extract patterns from your product',
    'Trích xuất hoa văn từ sản phẩm của bạn',
  ],
  [
    'Analyzing your product image for patterns',
    'Đang phân tích ảnh sản phẩm của bạn để tìm hoa văn',
  ],
  [
    'A standalone print has been detected in your image. Isolate it for logos, artwork, or unique graphics.',
    'Đã phát hiện một bản in độc lập trong ảnh của bạn. Hãy tách nó ra cho logo, tác phẩm nghệ thuật hoặc đồ họa độc đáo.',
  ],
  [
    'A repeatable pattern has been detected in your image. Extract it to create seamless tiles for textiles and surface designs.',
    'Đã phát hiện một hoa văn lặp lại trong ảnh của bạn. Hãy trích xuất nó để tạo ô lặp liền mạch cho dệt may và thiết kế bề mặt.',
  ],
  [
    'We could not confidently detect a repeatable pattern or isolated print in this image.',
    'Chúng tôi không thể tự tin phát hiện hoa văn lặp lại hoặc bản in tách biệt trong ảnh này.',
  ],
  ['Running visual analysis', 'Đang chạy phân tích hình ảnh'],
  [
    'Detecting patterns in your image',
    'Đang phát hiện hoa văn trong ảnh của bạn',
  ],
  ['Print detected', 'Đã phát hiện bản in'],
  ['Repeatable pattern detected', 'Đã phát hiện hoa văn lặp lại'],
  ['No pattern or print detected', 'Không phát hiện hoa văn hoặc bản in'],
  ['Repeatable Patterns', 'Hoa văn lặp lại'],
  [
    'Extract seamless, tiling patterns perfect for textiles, wallpapers, and surface designs. Patterns can be repeated infinitely without visible seams.',
    'Trích xuất các hoa văn liền mạch, lặp ô hoàn hảo cho dệt may, giấy dán tường và thiết kế bề mặt. Hoa văn có thể được lặp lại vô hạn mà không thấy đường nối.',
  ],
  ['Print Isolation', 'Tách bản in'],
  [
    'Isolate standalone prints, graphics, or artwork from your product. Perfect for logos, unique designs, or non-repeating elements.',
    'Tách các bản in, đồ họa hoặc tác phẩm nghệ thuật độc lập khỏi sản phẩm của bạn. Hoàn hảo cho logo, thiết kế độc đáo hoặc các yếu tố không lặp lại.',
  ],
  ['Back to Extraction', 'Quay lại trích xuất'],
  ['Continue to Extraction', 'Tiếp tục trích xuất'],
  ['How it works', 'Cách hoạt động'],
  ['Main Image', 'Ảnh chính'],
  ['Main product image', 'Ảnh chính của sản phẩm'],
  ['No main image available', 'Không có ảnh chính khả dụng'],
  ['Checking...', 'Đang kiểm tra...'],
  ['Isolating Print...', 'Đang tách bản in...'],
  ['Extracting Pattern...', 'Đang trích xuất hoa văn...'],
  ['No Print/Pattern Found', 'Không tìm thấy bản in/hoa văn'],
  ['Isolate Print', 'Tách bản in'],
  ['Extract Pattern', 'Trích xuất hoa văn'],
  ['Color', 'Màu sắc'],
  ['B&W', 'Đen trắng'],
  ['Color pattern', 'Hoa văn màu'],
  ['Black & White pattern', 'Hoa văn đen trắng'],
  ['Switch', 'Chuyển đổi'],
  ['Pattern Preview', 'Xem trước hoa văn'],
  ['Pattern Layers', 'Các lớp hoa văn'],
  ['layer', 'lớp'],
  ['layers', 'lớp'],
  ['Invalid asset ID', 'ID tài sản không hợp lệ'],
  [
    'Delete this layer? This action cannot be undone.',
    'Xóa lớp này? Không thể hoàn tác hành động này.',
  ],
  ['Deleting layer...', 'Đang xóa lớp...'],
  ['Layer deleted', 'Đã xóa lớp'],
  ['Layer was already deleted', 'Lớp đã bị xóa trước đó'],
  ['Failed to delete layer', 'Không thể xóa lớp'],
  ['Favorite layer', 'Đánh dấu lớp yêu thích'],
  ['Unfavorite layer', 'Bỏ đánh dấu lớp yêu thích'],
  ['Preview layer', 'Xem trước lớp'],
  ['Download layer', 'Tải xuống lớp'],
  ['Delete layer', 'Xóa lớp'],
  ['Selecting pattern...', 'Đang chọn hoa văn...'],
  ['Failed', 'Thất bại'],
  ['Final Selected Pattern', 'Hoa văn được chọn cuối cùng'],
  ['Set dimensions', 'Đặt kích thước'],
  ['Download pattern', 'Tải xuống hoa văn'],
  ['View fullscreen', 'Xem toàn màn hình'],
  ['No pattern selected', 'Chưa chọn hoa văn'],
  ['Pattern extraction failed', 'Trích xuất hoa văn thất bại'],
  ['Please try again', 'Vui lòng thử lại'],
  ['Try Again', 'Thử lại'],
  ['Extracted pattern', 'Hoa văn đã trích xuất'],
  ['Regenerate pattern', 'Tạo lại hoa văn'],
  ['Scales', 'Tỉ lệ'],
  ['Tile Dimensions', 'Kích thước ô'],
  ['Overall Dimensions', 'Kích thước tổng thể'],
  ['Units', 'Đơn vị'],
  ['Edit', 'Chỉnh sửa'],
  [
    'Click "Extract Pattern" to generate a seamless pattern',
    'Nhấn "Trích xuất hoa văn" để tạo hoa văn liền mạch',
  ],
  ['Set Pattern Dimensions', 'Đặt kích thước hoa văn'],
  [
    'Toggle pattern extraction information',
    'Bật/tắt thông tin trích xuất hoa văn',
  ],
  ['Show less', 'Hiển thị ít hơn'],
  ['Show more', 'Hiển thị thêm'],
  [
    'Analyzing your image to detect patterns or prints...',
    'Đang phân tích ảnh của bạn để phát hiện hoa văn hoặc bản in...',
  ],
  [
    'Extract standalone prints or graphics from your product image. Perfect for isolating logos, artwork, or unique designs.',
    'Trích xuất các bản in hoặc đồ họa độc lập từ ảnh sản phẩm của bạn. Hoàn hảo để tách logo, tác phẩm nghệ thuật hoặc thiết kế độc đáo.',
  ],
  [
    'Extract seamless, repeatable patterns from your product image. Perfect for textiles, wallpapers, and surface designs.',
    'Trích xuất các hoa văn liền mạch, lặp lại từ ảnh sản phẩm của bạn. Hoàn hảo cho dệt may, giấy dán tường và thiết kế bề mặt.',
  ],
  ['This may take a few seconds...', 'Quá trình này có thể mất vài giây...'],
  ['Detected:', 'Đã phát hiện:'],
  ['Pattern extracted successfully', 'Đã trích xuất hoa văn thành công'],
  [
    'Scroll to zoom (Ctrl/Cmd + Wheel), drag to pan',
    'Cuộn để phóng to (Ctrl/Cmd + con lăn), kéo để di chuyển',
  ],
  ['Reset', 'Đặt lại'],
  ['Fit', 'Vừa khung'],
  ['Fit pattern to screen', 'Đưa hoa văn vừa màn hình'],
  ['Export', 'Xuất'],
  [
    'Export full manufacturing file with tiled pattern at overall dimensions',
    'Xuất tệp sản xuất đầy đủ với hoa văn được lặp ô theo kích thước tổng thể',
  ],
  ['Export Manufacturing File', 'Xuất tệp sản xuất'],
  [
    'Choose the quality settings for your PNG manufacturing file',
    'Chọn cài đặt chất lượng cho tệp PNG sản xuất của bạn',
  ],
  ['Format', 'Định dạng'],
  ['PNG (Raster - High Quality)', 'PNG (Raster - Chất lượng cao)'],
  ['DPI (Resolution)', 'DPI (Độ phân giải)'],
  [
    'Higher DPI = Better quality but larger file size',
    'DPI cao hơn = chất lượng tốt hơn nhưng kích thước tệp lớn hơn',
  ],
  ['Export PNG', 'Xuất PNG'],
  ['Fine tuning print', 'Đang tinh chỉnh bản in'],
  ['Fine tuning pattern', 'Đang tinh chỉnh hoa văn'],
  ['Print extraction started', 'Đã bắt đầu trích xuất bản in'],
  [
    'The print is being isolated. It will appear here when ready.',
    'Bản in đang được tách ra. Nó sẽ xuất hiện ở đây khi sẵn sàng.',
  ],
  ['Pattern extraction started', 'Đã bắt đầu trích xuất hoa văn'],
  [
    'The pattern is being generated. It will appear here when ready.',
    'Hoa văn đang được tạo. Nó sẽ xuất hiện ở đây khi sẵn sàng.',
  ],
  [
    'Pattern extraction not recommended',
    'Không khuyến nghị trích xuất hoa văn',
  ],
  ['Pattern extraction failed', 'Trích xuất hoa văn thất bại'],
  ['Main image not found', 'Không tìm thấy ảnh chính'],
  ['Main image URL not available', 'URL ảnh chính không khả dụng'],
  ['Failed to extract print', 'Không thể trích xuất bản in'],
  ['Failed to extract pattern', 'Không thể trích xuất hoa văn'],
  ['Pattern data not available', 'Dữ liệu hoa văn không khả dụng'],
  ['Pattern Tile', 'Ô hoa văn'],
  ['Pattern tile downloaded as SVG', 'Đã tải ô hoa văn dưới dạng SVG'],
  ['Failed to download pattern tile', 'Không thể tải ô hoa văn'],
  ['Pattern dimensions not set', 'Chưa đặt kích thước hoa văn'],
  [
    'Unable to export PNG: Could not access image',
    'Không thể xuất PNG: Không thể truy cập ảnh',
  ],
  [
    'Unable to export PNG: Image access blocked',
    'Không thể xuất PNG: Quyền truy cập ảnh bị chặn',
  ],
  ['Failed to generate PNG', 'Không thể tạo PNG'],
  ['Failed to export PNG file', 'Không thể xuất tệp PNG'],
  [
    'Fullscreen is not supported in this browser',
    'Toàn màn hình không được hỗ trợ trên trình duyệt này',
  ],
  ['Pattern Dimensions', 'Kích thước hoa văn'],
  [
    'Set the dimensions for the pattern tile and overall pattern area. The pattern tile is 1:1, so X and Y will match.',
    'Đặt kích thước cho ô hoa văn và toàn bộ vùng hoa văn. Ô hoa văn là 1:1 nên X và Y sẽ khớp nhau.',
  ],
  ['Tile dimensions must be greater than 0', 'Kích thước ô phải lớn hơn 0'],
  [
    'Overall pattern dimensions must be greater than 0',
    'Kích thước tổng thể của hoa văn phải lớn hơn 0',
  ],
  ['Pattern dimensions saved', 'Đã lưu kích thước hoa văn'],
  ['Failed to save dimensions', 'Không thể lưu kích thước'],
  ['Error saving dimensions', 'Lỗi khi lưu kích thước'],
  ['Pattern Tile Dimensions (1:1)', 'Kích thước ô hoa văn (1:1)'],
  ['Width (X)', 'Chiều rộng (X)'],
  ['Height (Y)', 'Chiều cao (Y)'],
  ['(Auto-synced with width)', '(Tự động đồng bộ theo chiều rộng)'],
  ['Unit', 'Đơn vị'],
  ['Use same units throughout', 'Sử dụng cùng một đơn vị cho toàn bộ'],
  ['Overall Pattern Dimensions', 'Kích thước tổng thể của hoa văn'],
  ['Save Dimensions', 'Lưu kích thước'],
]);

const DYNAMIC_VI_PATTERNS: Array<{
  pattern: RegExp;
  replace: string;
}> = [
  { pattern: /^Preparing (\d+)\/(\d+)$/, replace: 'Đang chuẩn bị $1/$2' },
  { pattern: /^(\d+) files$/, replace: '$1 tệp' },
  { pattern: /^Undo \((\d+)s\)$/, replace: 'Hoàn tác ($1gi)' },
  {
    pattern: /^Generation will start in (\d+) seconds$/,
    replace: 'Quá trình tạo sẽ bắt đầu sau $1 giây',
  },
  {
    pattern: /^\{count\} selected$/,
    replace: '{count} mục đã chọn',
  },
  {
    pattern: /^All \(\{count\}\)$/,
    replace: 'Tất cả ({count})',
  },
  {
    pattern: /^\{count\} more versions available$/,
    replace: 'Còn {count} phiên bản nữa',
  },
];

function isPlainObject(value: unknown): value is Record<string, JsonLike> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function collectStringMappings(
  englishValue: JsonLike,
  localizedValue: JsonLike,
  mappings: Map<string, string>
) {
  if (typeof englishValue === 'string' && typeof localizedValue === 'string') {
    if (englishValue !== localizedValue) {
      mappings.set(englishValue, localizedValue);
    }
    return;
  }

  if (Array.isArray(englishValue) && Array.isArray(localizedValue)) {
    englishValue.forEach((value, index) => {
      collectStringMappings(value, localizedValue[index], mappings);
    });
    return;
  }

  if (isPlainObject(englishValue) && isPlainObject(localizedValue)) {
    Object.keys(englishValue).forEach((key) => {
      if (key in localizedValue) {
        collectStringMappings(englishValue[key], localizedValue[key], mappings);
      }
    });
  }
}

const AUTO_VI_TEXT = (() => {
  const mappings = new Map<string, string>();
  collectStringMappings(
    enMessages as JsonLike,
    viMessages as JsonLike,
    mappings
  );
  return mappings;
})();

export function localizeVietnameseStaticText(text: string): string {
  const explicit = EXTRA_VI_TEXT.get(text);
  if (explicit) {
    return explicit;
  }

  const inferred = AUTO_VI_TEXT.get(text);
  if (inferred) {
    return inferred;
  }

  for (const { pattern, replace } of DYNAMIC_VI_PATTERNS) {
    if (pattern.test(text)) {
      return text.replace(pattern, replace);
    }
  }

  return text;
}

function localizeVietnameseValue<T>(value: T): T {
  if (typeof value === 'string') {
    return localizeVietnameseStaticText(value) as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => localizeVietnameseValue(item)) as T;
  }

  if (typeof value === 'function') {
    return ((...args: unknown[]) => {
      const result = value(...args);
      return typeof result === 'string'
        ? localizeVietnameseStaticText(result)
        : localizeVietnameseValue(result);
    }) as T;
  }

  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, nestedValue]) => [
        key,
        localizeVietnameseValue(nestedValue),
      ])
    ) as T;
  }

  return value;
}

export function createVietnameseStaticCopy<T>(value: T): T {
  return localizeVietnameseValue(value);
}

export function overlayVietnameseMessages<T extends Record<string, unknown>>(
  messages: T
): T {
  return createVietnameseStaticCopy(messages);
}
